import { createContext, useContext } from 'react';
import type { SessionUser } from '../lib/api.js';

export type CompanyContext = NonNullable<SessionUser['currentTenant']>;

export interface CompanyScope {
  user: SessionUser;
  company: CompanyContext;
  isRoot: boolean;
  /// Root alcança tudo; para o resto vale a lista que o servidor mandou, **já filtrada pela
  /// contratação**: permissão de módulo que a empresa não contratou não chega até aqui.
  can: (permission: string) => boolean;
  timeZone: string;
  today: string;
}

const context = createContext<CompanyScope | null>(null);

export const CompanyScopeProvider = context.Provider;

/// Quem está logado, em qual empresa, e o que pode fazer nela.
///
/// A única coisa que monta este contexto é a casca da empresa, e ela é rota-mãe de todas as telas
/// que o consomem — não existe caminho que renderize uma tela de empresa fora dela. Por isso o
/// valor é lido como certo, em vez de cada tela carregar um `if` para um caso que a árvore de
/// rotas torna impossível.
export function useCompanyScope(): CompanyScope {
  return useContext(context)!;
}
